import request from '@/api/request'

export function register(data) {
  return request({
    url: '/account',
    method: 'post',
    data: data
  });
}

export function updatePassword(data) {
  return request({
    url: '/account',
    method: 'put',
    data: data
  });
}



// WEBPACK FOOTER //
// ./src/api/account.js